import { FC } from 'react'
import { Grid, IconButton, makeStyles, Paper, Typography } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import VisibilityIcon from '@material-ui/icons/Visibility'

import Status from './Status'

import useTranslate from '../../../i18n/useTranslate'
import { convertDateToFormatTH } from '../../../utilities/date'

import { ResponseT } from '../../../services/um/useExternalResearcher'
import { ButtonView } from '../../../control/button/button'

interface ItemProps {
    onClickEdit: (userID: string) => void
    data: ResponseT
}
const Item: FC<ItemProps> = ({ onClickEdit, data }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    const renderIcon = () => {
        if (data.status.id === '1') {
            return (
                <ButtonView className={classes.btnEdit} onClick={() => onClickEdit(data.userID)}>
                    {translate.get('BUTTON.EDIT')}
                </ButtonView>
            )
        } else {
            return (
                <IconButton onClick={() => onClickEdit(data.userID)} aria-label="edit" className={classes.icon}>
                    <VisibilityIcon />
                </IconButton>
            )
        }
    }

    return (
        <Paper className={classes.item} variant="outlined">
            <Grid container spacing={2} alignItems="center">
                <Grid container item xs={12} sm={12} md={2} lg={2} alignItems="center">
                    {renderIcon()}
                </Grid>
                <Grid container item xs={12} sm={12} md={4} lg={4} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.header}>{translate.get('UM.USERGROUP.FULLNAME')}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{data.name[lang]}</Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={3} lg={3} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.header}>
                            {translate.get('UM.EXTERNAL-RESEARCHER.REGISTER-DATE')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>
                            {convertDateToFormatTH(data.registerDate, 'DD MMMM YYYY')}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={3} lg={3} className={classes.status}>
                    <Status id={data.status.id} name={data.status.name[lang]} />
                </Grid>
            </Grid>
        </Paper>
    )
}

const useStyles = makeStyles((theme) => ({
    icon: {
        margin: theme.spacing(1),

        width: 40,
        height: 40,
        backgroundColor: '#ece9e9',
        transition: '0.3s',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    },
    status: {
        [theme.breakpoints.down('md')]: {
            marginTop: '10px',
        },
    },
    header: {
        fontWeight: 'bold',
    },

    item: {
        padding: theme.spacing(3),
        marginBottom: '10px',
        marginRight: '0px',
        transition: '0.3s',
        position: 'relative',
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    btnEdit: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '44px',
        marginRight: '1px',
    },
    multiLineEllipsis: {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
    },
}))

export default Item
